var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrade = function SvgGrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 121 139"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "grade_svg__a",
    d: "M0 .072h83.363v124.972H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grade_svg__c",
    d: "M0 125.044h83.363V.072H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grade_svg__e",
    d: "M0 .072h83.363v124.972H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grade_svg__g",
    d: "M0 125.044h83.363V.072H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grade_svg__i",
    d: "M0 .072h83.363v124.972H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "grade_svg__k",
    d: "M0 125.044h83.363V.072H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 61.38 10.88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "grade_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#grade_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAAE",
    d: "M80.028 125.045H3.334A3.335 3.335 0 0 1 0 121.71V3.406A3.334 3.334 0 0 1 3.334.072h59.193l20.836 20.836V121.71a3.335 3.335 0 0 1-3.335 3.335",
    mask: "url(#grade_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD13F",
    d: "M62.526.072v17.502a3.335 3.335 0 0 0 3.335 3.334h17.502z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "grade_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#grade_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EDB20A",
    d: "M10.048 71.944h63.267v-3.335H10.048zM10.048 62.124h63.267v-3.335H10.048zM10.048 81.764h63.267v-3.335H10.048zM10.048 91.709h33.301v-3.335H10.048zM57.243 109.001h16.072v-3.334H57.243z",
    mask: "url(#grade_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M36.06 23.95h1.413c.307 0 .556.248.556.555v2.09c0 .307.248.556.556.556h2.107c.307 0 .556.248.556.556v1.342a.556.556 0 0 1-.556.556h-2.107a.555.555 0 0 0-.556.556v2.089a.556.556 0 0 1-.556.556H36.06a.556.556 0 0 1-.556-.556v-2.09a.556.556 0 0 0-.556-.555h-2.107a.556.556 0 0 1-.556-.556v-1.342c0-.308.249-.556.556-.556h2.107a.556.556 0 0 0 .556-.556v-2.09c0-.307.248-.555.556-.555M19.393 28.313c0-3.524 2.617-6.244 6.243-6.244 1.991 0 3.785.92 4.878 2.387a.484.484 0 0 1-.143.71l-1.818 1.044a.47.47 0 0 1-.608-.118c-.511-.65-1.353-1.03-2.309-1.03-1.933 0-3.198 1.335-3.198 3.25s1.265 3.25 3.198 3.25c.955 0 1.798-.38 2.309-1.04a.47.47 0 0 1 .611-.12l1.819 1.056c.25.146.313.477.141.709-1.09 1.467-2.872 2.388-4.88 2.388-3.626 0-6.243-2.719-6.243-6.242",
    mask: "url(#grade_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M30.566 48.88c-5.243 0-10.486-1.996-14.478-5.988-7.984-7.984-7.984-20.974 0-28.957a20.34 20.34 0 0 1 14.479-5.998 1.667 1.667 0 1 1 0 3.335 17.03 17.03 0 0 0-12.122 5.02c-6.683 6.684-6.683 17.559 0 24.242 6.685 6.683 17.558 6.684 24.243 0a17.03 17.03 0 0 0 5.02-12.153 17.03 17.03 0 0 0-5.02-12.089 1.666 1.666 0 1 1 2.357-2.357 20.34 20.34 0 0 1 5.997 14.44 20.34 20.34 0 0 1-5.997 14.517c-3.992 3.992-9.235 5.988-14.479 5.988",
    mask: "url(#grade_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 61.38 10.88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "grade_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#grade_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAAE",
    d: "M80.028 125.045H3.334A3.335 3.335 0 0 1 0 121.71V3.406A3.334 3.334 0 0 1 3.334.072h59.193l20.836 20.836V121.71a3.335 3.335 0 0 1-3.335 3.335",
    mask: "url(#grade_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD13F",
    d: "M62.526.072v17.502a3.335 3.335 0 0 0 3.335 3.334h17.502z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "grade_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#grade_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EDB20A",
    d: "M10.047 71.944h63.268v-3.335H10.047zM10.047 62.124h63.268v-3.335H10.047zM10.047 81.764h63.268v-3.335H10.047zM10.047 91.709H43.35v-3.335H10.047zM57.242 109.001h16.073v-3.334H57.242z",
    mask: "url(#grade_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M27.746 30.85c0-.836-.623-1.353-2.028-1.353h-2.61a.556.556 0 0 0-.555.556v1.627c0 .307.249.556.556.556h2.698c1.21 0 1.939-.426 1.939-1.352zm-.694-4.98c0-.818-.64-1.28-1.795-1.28h-2.148a.556.556 0 0 0-.556.556v1.52c0 .306.249.555.556.555h1.97c1.208 0 1.973-.39 1.973-1.316zm-1.245 8.767h-5.366a.556.556 0 0 1-.556-.556V22.745c0-.307.25-.556.556-.556h5.224c2.543 0 4.108 1.262 4.108 3.218v.036c0 .992-.373 1.674-.905 2.164-.282.26-.25.71.083.902.954.55 1.516 1.35 1.516 2.678v.036c0 2.276-1.85 3.414-4.66 3.414M36.06 23.95h1.413c.307 0 .556.248.556.555v2.09c0 .307.248.556.556.556h2.107c.307 0 .556.248.556.556v1.342a.556.556 0 0 1-.556.556h-2.107a.555.555 0 0 0-.556.556v2.089a.556.556 0 0 1-.556.556H36.06a.556.556 0 0 1-.556-.556v-2.09a.556.556 0 0 0-.556-.555h-2.107a.556.556 0 0 1-.556-.556v-1.342c0-.308.249-.556.556-.556h2.107a.556.556 0 0 0 .556-.556v-2.09c0-.307.248-.555.556-.555",
    mask: "url(#grade_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M30.566 48.88c-5.244 0-10.487-1.996-14.479-5.988-7.983-7.984-7.983-20.974 0-28.957a20.34 20.34 0 0 1 14.48-5.998 1.667 1.667 0 1 1 0 3.335 17.03 17.03 0 0 0-12.122 5.02c-6.683 6.684-6.683 17.559 0 24.242 6.684 6.683 17.557 6.684 24.242 0a17.03 17.03 0 0 0 5.021-12.153 17.04 17.04 0 0 0-5.02-12.089 1.666 1.666 0 1 1 2.357-2.357 20.35 20.35 0 0 1 5.998 14.44 20.34 20.34 0 0 1-5.998 14.517c-3.992 3.992-9.235 5.988-14.48 5.988",
    mask: "url(#grade_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 61.38 10.88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "grade_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#grade_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEFBB",
    d: "M80.028 125.045H3.334A3.335 3.335 0 0 1 0 121.71V3.406A3.334 3.334 0 0 1 3.334.072h59.193l20.836 20.836V121.71a3.335 3.335 0 0 1-3.335 3.335",
    mask: "url(#grade_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD75D",
    d: "M62.526.072v17.502a3.335 3.335 0 0 0 3.335 3.334h17.502z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "grade_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#grade_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC000",
    d: "M10.048 71.944h63.267v-3.335H10.048zM10.048 62.124h63.267v-3.335H10.048zM10.048 81.764h63.267v-3.335H10.048zM10.048 91.709h33.3v-3.335h-33.3zM57.242 109.001h16.073v-3.334H57.242z",
    mask: "url(#grade_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M40.521 27.15c.401 0 .727.326.727.727v1.001a.727.727 0 0 1-.727.727h-7.51a.727.727 0 0 1-.726-.727v-1c0-.402.325-.727.726-.727zM26.384 28.934l-.555-1.86a.49.49 0 0 0-.938.002l-.547 1.86a.49.49 0 0 0 .47.627h1.1a.49.49 0 0 0 .47-.63m.61 3.263h-3.256a.49.49 0 0 0-.469.35l-.306 1.028a.49.49 0 0 1-.469.35h-2.277a.49.49 0 0 1-.464-.643l3.629-10.995a.49.49 0 0 1 .465-.335h3.02c.211 0 .4.135.465.335l3.628 10.995a.49.49 0 0 1-.464.643h-2.26a.49.49 0 0 1-.469-.35l-.305-1.028a.49.49 0 0 0-.469-.35",
    mask: "url(#grade_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M30.566 48.88c-5.244 0-10.487-1.996-14.479-5.988-7.983-7.984-7.983-20.974 0-28.957a20.34 20.34 0 0 1 14.48-5.998 1.667 1.667 0 1 1 0 3.335 17.03 17.03 0 0 0-12.122 5.02c-6.683 6.684-6.683 17.559 0 24.242 6.684 6.683 17.558 6.684 24.242 0a17.03 17.03 0 0 0 5.021-12.153 17.04 17.04 0 0 0-5.02-12.089 1.666 1.666 0 1 1 2.357-2.357 20.35 20.35 0 0 1 5.998 14.44 20.34 20.34 0 0 1-5.998 14.517c-3.992 3.992-9.235 5.988-14.48 5.988",
    mask: "url(#grade_svg__l)"
  })))));
};
export default SvgGrade;